// ABOUTME: Universal info modal for displaying detailed information on mobile/desktop
// ABOUTME: Shows as centered modal with close button. Replaces CTooltipModal and CTooltipModal2

import type { Dispatch, ReactNode, SetStateAction } from "react"
import { CModalCore } from "./CModalCore"

interface CInfoModalProps {
  isShow: boolean
  setIsShow: Dispatch<SetStateAction<boolean>>
  content: ReactNode
  title?: string
  subTitle?: string
}

export const CInfoModal = ({ isShow, setIsShow, content, title, subTitle }: CInfoModalProps) => {
  const handleClose = () => setIsShow(false)

  const headerTitle = subTitle ? (
    <div>
      <div>{title}</div>
      <div className="text-sm font-normal text-gray-500">{subTitle}</div>
    </div>
  ) : (
    title
  )

  return (
    <CModalCore
      isOpen={isShow}
      onClose={handleClose}
      title={headerTitle}
      modalBodyContent={content}
      btns={[{ type: "cancel", action: handleClose }]}
      position="center"
      showCloseButton
    />
  )
}
